async function postAction(body: Record<string, unknown>, idToken: string): Promise<void> {
  const res = await fetch('/api/blog/app-build', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const errBody = (await res.json().catch(() => ({}))) as { error?: string; detail?: string };
    throw new Error(errBody.detail ?? errBody.error ?? `HTTP ${res.status}`);
  }
}

export function startAppBuildUpload(
  input: { fileName: string; sizeBytes: number; contentType: string; chunkCount: number },
  idToken: string
): Promise<void> {
  return postAction({ action: 'start', ...input }, idToken);
}

export function uploadAppBuildChunk(index: number, data: string, idToken: string): Promise<void> {
  return postAction({ action: 'chunk', index, data }, idToken);
}

export function finishAppBuildUpload(idToken: string): Promise<void> {
  return postAction({ action: 'finish' }, idToken);
}

export interface AppEdition {
  id: string;
  enabled: boolean;
  permanentlyEnded: boolean;
  updatedAt?: number;
  updatedBy?: string;
}

export type AppEditionAction = 'register' | 'enable' | 'end' | 'end_permanently';

export async function listAppEditions(idToken: string): Promise<AppEdition[]> {
  const res = await fetch('/api/app-edition', {
    headers: { Authorization: `Bearer ${idToken}` },
  });
  if (!res.ok) {
    const errBody = (await res.json().catch(() => ({}))) as { error?: string; detail?: string };
    throw new Error(errBody.detail ?? errBody.error ?? `HTTP ${res.status}`);
  }
  const data = (await res.json()) as { editions: AppEdition[] };
  return data.editions;
}

export async function applyAppEditionAction(
  editionId: string,
  action: AppEditionAction,
  idToken: string
): Promise<AppEdition> {
  const res = await fetch('/api/app-edition', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ editionId, action }),
  });
  if (!res.ok) {
    const errBody = (await res.json().catch(() => ({}))) as { error?: string; detail?: string };
    throw new Error(errBody.detail ?? errBody.error ?? `HTTP ${res.status}`);
  }
  const data = (await res.json()) as AppEdition & { ok: true };
  return data;
}
